import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth.js';
import { Box, CircularProgress, Typography } from '@mui/material';

export const RoleBasedRedirect = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        navigate('/login', { replace: true });
      } else if (user) {
        // Redirect based on user role
        if (user.role === 'superadmin') {
          navigate('/super-admin/dashboard', { replace: true });
        } else if (user.role === 'vendor') {
          navigate('/vendor/dashboard', { replace: true });
        } else {
          navigate('/dashboard', { replace: true }); // fallback
        }
      }
    }
  }, [isAuthenticated, user, loading, navigate]);

  // Show loading spinner while checking authentication
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="body1" color="text.secondary">
        Redirecting...
      </Typography>
    </Box>
  );
};